import { useSelector } from "react-redux";
import { useEffect } from "react";

// Api
import { userApi } from "redux/user/api";

// Components

// Selectors
import * as authSelectors from "redux/auth/selectors";
import * as userSelectors from "redux/user/selectors";

// Types
import { BONUS_STATUS, BONUS_TYPES, BonusMappedType } from "types/Bonus";
import BonusWidget from "../../components/molecules/BonusWidget/BonusWidget";

const BonusWidgetContainer = () => {
  userApi.useBonusesQuery("");
  const [trigger] = userApi.useLazyBonusesQuery();

  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const { bonuses } = useSelector(userSelectors.all);

  useEffect(() => {
    if (isAuthenticated) {
      trigger("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  if (!bonuses || !isAuthenticated) {
    return null;
  }

  const list: BonusMappedType[] = [];
  if (bonuses) {
    list.push(...bonuses);
  }
  const bonus = list.find(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    (bonus) =>
      bonus.status.toLowerCase() === BONUS_STATUS.ACTIVE &&
      bonus.type === BONUS_TYPES.REWARD,
  );

  return bonus ? <BonusWidget bonus={bonus} /> : null;
};
export default BonusWidgetContainer;
